import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import MedicationAssessment from './MedicationAssessment';

const MedicationCard = () => {
  const contentText = 'Your symptom(s) may also be a potential side effect of your medication(s).';
  const theme = useTheme();

  return (
    <Grid className="BuoyInterviews__MedicationCard bp-h-full" item sx={{ width: '100%' }}>
      <Card variant="outlined" className="bp-h-full bp-shadow-sm">
        <Grid
          container
          direction="column"
          spacing={1}
          sx={{ padding: 2.5 }}
          className="bp-flex bp-flex-1 bp-flex-nowrap"
        >
          <Grid item>
            <Chip
              label="New"
              sx={{
                padding: '0',
                marginBottom: '4px',
                height: '18px',
                fontSize: '12px',
                textTransform: 'capitalize',
                color: theme.palette.common.white,
                backgroundColor: theme.palette.primary.main,
                '>span': {
                  padding: '10px',
                },
              }}
            />
          </Grid>
          <Grid item paddingBottom={0}>
            <Typography sx={{ fontSize: '14px', lineHeight: '120%' }} variant="body2">
              {contentText}
            </Typography>
          </Grid>
        </Grid>
        <MedicationAssessment />
      </Card>
    </Grid>
  );
};

export default MedicationCard;
